import { MapLocation } from '@/types/location';
import { jeddahSchools } from './jeddahSchools';
import { riyadhSchools } from './riyadhSchools';
import { easternSchools } from './easternSchools';
import { wakiSchoolsJeddah } from './wakiSchoolsJeddah';
import { wakiSchoolsRiyadh } from './wakiSchoolsRiyadh';
import { wakiSchoolsEastern } from './wakiSchoolsEastern';

// Filter out any Waki schools from all school collections
const filterNonWakiSchools = (schools: MapLocation[]) => 
  schools.filter(school => school.mediaOwner !== 'Waki');

// Combine all Waki school locations by region
export const wakiSchools: MapLocation[] = [
  ...wakiSchoolsJeddah,
  ...wakiSchoolsRiyadh,
  ...wakiSchoolsEastern
];

// Keep the exported array name the same for backward compatibility
// but it no longer contains Waki schools
export const nonWakiSchoolLocations: MapLocation[] = [
  ...filterNonWakiSchools(jeddahSchools),
  ...filterNonWakiSchools(riyadhSchools),
  ...filterNonWakiSchools(easternSchools)
];
